import { Pipe, PipeTransform } from '@angular/core';
import { APIsettings } from '../../app/app.config';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'userDuration'
})

export class UserDurationPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    let dayParts = '', timeParts = '';

    if (value.includes(' ')) {
      [dayParts, timeParts] = value.split(' ');
    } else {
      timeParts = value;
    }
    let totalDays = parseInt(dayParts);
    const parts = timeParts.split(':');
    const hours = parseInt(parts[0]) % 24;
    const minutes = parseInt(parts[1]);
    const seconds = parseInt(parts[2]);

    let result = '';

    if (totalDays >= 365) {
      const years = Math.floor(totalDays / 365);
      result += years === 1 ? '1 year ' : `${years} years `;
      totalDays = totalDays % 365;
    }
    if (totalDays >= 30) {
      const months = Math.floor(totalDays / 30);
      result += months === 1 ? '1 month ' : `${months} months `;
      totalDays = totalDays % 30;
    }
    if (totalDays >= 7) {
      const weeks = Math.floor(totalDays / 7);
      result += weeks === 1 ? '1 week ' : `${weeks} weeks `;
      totalDays = totalDays % 7;
    }
    if (totalDays > 0) {
      result += totalDays === 1 ? '1 day ' : `${totalDays} days `;
    }

    if (hours > 0) {
      result += hours === 1 ? '1 hour ' : `${hours} hours `;
    }
    if (minutes > 0) {
      result += minutes === 1 ? '1 min ' : `${minutes} mins `;
    }
    if (seconds > 0) {
      result += seconds === 1 ? '1 sec' : `${seconds} secs`;
    }

    return result.trim();
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_pipes/user-duration.pipe.ts